import { Link as RouterLink } from 'react-router'
import classNames from 'classnames'

import { LINK_BASIC } from './Link.constants'

import * as styles from './Link.module.css'

function Link({
  children,
  className,
  disabled,
  ref,
  to,
  variant = LINK_BASIC,
  ...restProps
}) {
  const linkClassName = classNames(
    styles.link,
    styles[variant],
    { [styles.disabled]: disabled },
    className
  )

  return (
    <RouterLink {...restProps} className={linkClassName} ref={ref} to={to}>
      {children}
    </RouterLink>
  )
}

export default Link
